export enum LOCAL_STORAGE_KEYS {
  TOKEN = "token",
}
